import { useState, useEffect, useRef } from 'react';

const useSecElementOnScreen = (options) => {
  const itemTwoRef = useRef(null);
  const [isInView, setIsInView] = useState(false);

  const animateCallback = (entries) => {
    const [entry] = entries;
    if (entry.isIntersecting) {
      setIsInView(entry.isIntersecting);
    }
  };

  useEffect(() => {
    // cleanOb();
    const observer = new IntersectionObserver(animateCallback, options);
    if (itemTwoRef.current) {
      observer.observe(itemTwoRef.current);
    }

    return () => {
      if (itemTwoRef.current) {
        observer.unobserve(itemTwoRef.current);
      }
      // cleanOb();
    };
  }, [itemTwoRef, options]);
  return [itemTwoRef, isInView];
};

export default useSecElementOnScreen;
